import { Box, Icon, Tag } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const AiTag = () => (
  <Tag inline type="purple">
    <Box flexDirection="row" gap="s4" paddingX="s4" alignItems="center">
      <Icon.Small icon="ai" color="grey800" />
      {i18n.t('performance_process.insights.factorial_ai')}
    </Box>
  </Tag>
)
